import React, { FC } from 'react';
import { Modal } from '@ch/common/components/modal';
import { Heading } from '@ch/common/components/heading';
import { Button } from '@ch/common/components/button';
import { Col, Row } from 'styled-bootstrap-grid';

export interface PageComponentWrapProps {
  isOpen?: boolean;
  hideClose?: boolean;
  title?: string;
  onClose?: () => void;
  onSubmit?: {
    title: string;
    action: () => void;
  };
  onBack?: {
    title: string;
    action: () => void;
  };
  btnTheme?: {
    bg: string;
    bgHover: string;
    color: string;
    colorHover: string;
  };
}

const ModalSimple: FC<PageComponentWrapProps> = ({
  title,
  children,
  onBack,
  hideClose,
  isOpen,
  onSubmit,
  onClose,
  btnTheme,
}) => (
  <Modal isOpen={isOpen} $size="sm" onClose={onClose}>
    {title && (
      <Modal.Header hideClose={hideClose}>
        <Heading as="h4" $m={[0]} $size="h3">
          {title}
        </Heading>
      </Modal.Header>
    )}
    {children && <Modal.Body>{children}</Modal.Body>}
    <Modal.Footer>
      <Row>
        <Col col={6}>
          {onBack && (
            <Button $variant="outlined" $size="sm" $color="primary" onClick={onBack.action} $fullWidth>
              {onBack.title}
            </Button>
          )}
        </Col>
        <Col col={6}>
          {onSubmit && (
            <Button
              $size="sm"
              $defaultColor={{ ...btnTheme }}
              $color="red"
              onClick={() => onSubmit.action?.()}
              $fullWidth
            >
              {onSubmit.title}
            </Button>
          )}
        </Col>
      </Row>
    </Modal.Footer>
  </Modal>
);

ModalSimple.defaultProps = {
  isOpen: false,
};

export default ModalSimple;
